import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rt-nav-menu-popover',
  templateUrl: './rt-nav-menu-popover.component.html',
  styleUrls: ['./rt-nav-menu-popover.component.scss'],
})
export class RtNavMenuPopoverComponent implements OnInit {
  showCarburant = true;
  notificationCount = 0;
  private onRealtime: () => void;
  private onCarburant: () => void;
  private onAlerts: (ev?: any) => void;

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private router: Router,
  ) {}

  ngOnInit() {
    this.showCarburant = this.navParams.get('showCarburant') !== false;
    this.notificationCount = this.navParams.get('notificationCount') || 0;
    this.onRealtime = this.navParams.get('onRealtime');
    this.onCarburant = this.navParams.get('onCarburant');
    this.onAlerts = this.navParams.get('onAlerts');
  }

  async onRealtimeClick() {
    await this.popoverCtrl.dismiss();
    if (this.onRealtime) {
      this.onRealtime();
    }
  }

  async onCarburantClick() {
    await this.popoverCtrl.dismiss();
    if (this.onCarburant) {
      this.onCarburant();
    }
  }

  async onAlertsClick() {
    await this.popoverCtrl.dismiss();
    if (this.onAlerts) {
      this.onAlerts();
    }
  }

  async navigate(path: string) {
    await this.popoverCtrl.dismiss();
    this.router.navigate([path]);
  }
}
